'use client'

import { getLocalStorageAdapter } from '@/lib/storageAdapter'
import { useEffect } from 'react'

export const UTM_KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'fbclid',
    'gad_source',
    'gad_campaignid',
]

type UTMKey = (typeof UTM_KEYS)[number]
export type UTMData = Partial<Record<UTMKey, string>>

export const UTM_STORAGE_KEY = 'utm'

export function useUrlParams() {
    useEffect(() => {
        if (typeof window === 'undefined') return
        const storage = getLocalStorageAdapter()

        const searchParams = new URLSearchParams(window.location.search)
        const fromUrl: UTMData = {}

        UTM_KEYS.forEach((key) => {
            const val = searchParams.get(key)
            if (val) fromUrl[key] = val
        })

        if (Object.keys(fromUrl).length === 0) return

        const stored = storage.getItem(UTM_STORAGE_KEY)
        if (stored) return

        storage.setItem(UTM_STORAGE_KEY, JSON.stringify(fromUrl))
    }, [])
}

export function getUtmFromStorage(): Record<string, string> | null {
    const storage = getLocalStorageAdapter()
    const stored = storage.getItem(UTM_STORAGE_KEY)
    if (!stored) return null

    try {
        const parsed = JSON.parse(stored)
        if (typeof parsed === 'object' && parsed !== null && Object.keys(parsed).length > 0) {
            return parsed
        }
    } catch {
        // Ignore malformed data
    }

    return null
}

export function clearUtmFromStorage() {
    const storage = getLocalStorageAdapter()
    storage.removeItem(UTM_STORAGE_KEY)
}
